import { Box, Typography } from "@mui/material";
import { useMemo } from "react";

type ModalTitleType = {
  overviewType: "END" | "START";
  overviewInfo: any;
};
export const ModalTitle = ({ overviewInfo, overviewType }: ModalTitleType) => {
  var reportV1 = useMemo(() => overviewInfo.v1, [overviewInfo.v1]);
  var reportV2 = useMemo(() => overviewInfo.v2, [overviewInfo.v2]);
  var report = useMemo(
    () => ({
      total: {
        done: reportV1?.total?.done + reportV2?.total?.done,
        fail: reportV1?.total?.fail + reportV2?.total?.fail,
        todo: reportV1?.total?.todo + reportV2?.total?.todo,
      },
    }),
    [
      reportV1.total?.done,
      reportV1.total.fail,
      reportV1.total.todo,
      reportV2.total?.done,
      reportV2.total.fail,
      reportV2.total.todo,
    ]
  );

  const startMessage = useMemo(
    () => "Sending daily report to " + report.total.todo + " accounts",
    [report?.total?.todo]
  );
  const endMessage = useMemo(() => {
    let message =
      "Daily report sent to " +
      report?.total?.done +
      "/" +
      report?.total?.todo +
      " accounts";
    if (report?.total?.fail) {
      message = message + " (" + report?.total?.fail + " fails)";
    }
    return message;
  }, [report?.total?.done, report?.total?.fail, report?.total?.todo]);
  return (
    <Box>
      {overviewType === "START" && <Typography>{startMessage}</Typography>}
      {overviewType === "END" && <Typography>{endMessage}</Typography>}
    </Box>
  );
};
